export default "__VITE_ASSET__Diso1LEJ__"